module.exports = __webpack_public_path__ + "img/green-tick.c9f0b1c7.png";